var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'ucenter':_vm.$route.name === 'Ucenter','game-bg':_vm.$route.name === 'comingSoon','game-bg2':_vm.$route.name === 'game'},attrs:{"id":"app"}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"main"},[_c('answer-header',{attrs:{"pathname":_vm.pathName}}),_vm._v(" "),_c('router-view')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d183b9d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 